import { render, staticRenderFns } from "./KeywordFilter.vue?vue&type=template&id=0e650d10&scoped=true&"
import script from "./KeywordFilter.vue?vue&type=script&lang=js&"
export * from "./KeywordFilter.vue?vue&type=script&lang=js&"
import style0 from "./KeywordFilter.vue?vue&type=style&index=0&id=0e650d10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e650d10",
  null
  
)

export default component.exports